export default __webpack_public_path__ + "locales/pl/Payments.json?hash=9b883b86211b362f4968044417f302b8";